import React from 'react'
import Nav from '../Component/Nav/Nav'
import Banner2 from '../Component/Banner/Banner2'
import Slove from '../Component/ProblemSlove/Slove'
import Footer from '../Component/Footer/Footer'

export default function Problems() {
  return (
    <>
       <Nav/>
       <Banner2 bannerName="Problem Solving"/>
       <Slove/>
       <Footer/>
    </>
  )
}
